// extracted by mini-css-extract-plugin
module.exports = {"inputArea":"_7Dkm7XGYgC-V122aJlRc-A==","buttonArea":"FC-JFIZ-45vaKJouwGlbEw==","orderLine":"_8IyvUm9FWTiV+ZeY8FKz-w=="};